import { Grid } from '@mui/material';
import { memo } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import { AccordionResponsibleDataVM } from 'cohabitation/view-models/detail-cohabitation';

interface FormDataCohabitationResponsibleProps {
  disabled?: boolean;
  values?: AccordionResponsibleDataVM;
  isEditMode?: boolean;
  onChange: (
    key: keyof AccordionResponsibleDataVM,
    value: AccordionResponsibleDataVM[keyof AccordionResponsibleDataVM]
  ) => void;
}

const FormDataCohabitationResponsibleComponent = ({
  disabled,
  values,
  onChange,
  isEditMode,
}: FormDataCohabitationResponsibleProps): React.ReactElement => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <DatePicker
          label="Data responsabile convivenza"
          value={values?.date || null}
          disabled={isEditMode ? false : disabled}
          onChange={(dataValue) => {
            onChange('date', dataValue || null);
          }}
          renderInput={(params) => (
            <PmiTextField {...params} id="date-responsible" fullWidth error={false} helperText="" />
          )}
        />
      </Grid>
    </Grid>
  );
};

FormDataCohabitationResponsibleComponent.displayName = 'Form Cohabitation data component';

const FormDataCohabitationResponsible = memo(FormDataCohabitationResponsibleComponent);

export default FormDataCohabitationResponsible;
